"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.visibleTransferOrchestrationStepKeys = exports.mergeTransferOutputWithDefaults = exports.TRANSFER_ORCHESTRATION_STEP_KEYS = exports.normalizeLegacyTransferOutput = exports.LINK_CUSTOMER_TO_TARGET_SUBSIDIARY_STEP_NAME = exports.LINK_CUSTOMER_TO_TARGET_SUBSIDIARY_STEP_KEY = exports.initialTransferOutput = exports.SubscriptionTransferRequestStatus = exports.StepStatus = exports.SubscriptionTransferRequestType = void 0;
var SubscriptionTransferRequestType;
(function (SubscriptionTransferRequestType) {
    SubscriptionTransferRequestType["SUBTRANSFER"] = "SUBTRANSFER";
})(SubscriptionTransferRequestType || (exports.SubscriptionTransferRequestType = SubscriptionTransferRequestType = {}));
var StepStatus;
(function (StepStatus) {
    StepStatus["NOT_INITIATED"] = "NOT_INITIATED";
    StepStatus["IN_PROGRESS"] = "IN_PROGRESS";
    StepStatus["COMPLETED"] = "COMPLETED";
    StepStatus["FAILED"] = "FAILED";
    StepStatus["SKIPPED"] = "SKIPPED";
})(StepStatus || (exports.StepStatus = StepStatus = {}));
var SubscriptionTransferRequestStatus;
(function (SubscriptionTransferRequestStatus) {
    SubscriptionTransferRequestStatus["COMPLETED"] = "COMPLETED";
    SubscriptionTransferRequestStatus["IN_PROGRESS"] = "IN_PROGRESS";
    SubscriptionTransferRequestStatus["FAILED"] = "FAILED";
})(SubscriptionTransferRequestStatus || (exports.SubscriptionTransferRequestStatus = SubscriptionTransferRequestStatus = {}));
exports.initialTransferOutput = {
    SubscriptionLinesAndPriceIntervals: {
        name: "Create Negative Line Items",
        status: StepStatus.NOT_INITIATED,
    },
    TerminateSubsciption: {
        name: "Terminate Subsciption",
        status: StepStatus.NOT_INITIATED,
    },
    ChangeCustomerPreferences: {
        name: "Change Customer Preferences",
        status: StepStatus.NOT_INITIATED,
    },
    VerifyCmInvoiceAmountParity: {
        name: "Verify CM / Invoice Amount Parity",
        status: StepStatus.NOT_INITIATED,
    },
    CreateCreditMemo: {
        name: "Create Credit Memo",
        status: StepStatus.NOT_INITIATED,
    },
    RenameCreditMemoToInternalOnly: {
        name: "Rename Credit Memo To Internal Only",
        status: StepStatus.NOT_INITIATED,
    },
    RevertPreferences: {
        name: "Revert Preferences",
        status: StepStatus.NOT_INITIATED,
    },
    LinkCustomerToTargetSubsidiary: {
        name: "Link Customer to Target Subsidiary",
        status: StepStatus.NOT_INITIATED,
    },
    CreateBillingAccount: {
        name: "Create New Billing Account",
        status: StepStatus.NOT_INITIATED,
    },
    CreateNewSubscription: {
        name: "Create New Subscription",
        status: StepStatus.NOT_INITIATED,
    },
    SyncBothSubscriptions: {
        name: "Sync Both Subscriptions",
        status: StepStatus.NOT_INITIATED,
    },
    CreateNewInvoice: {
        name: "Create New Internal Invoice",
        status: StepStatus.NOT_INITIATED,
    },
    ApplyCustomerPayment: {
        name: "Apply Customer Payment To Invoice",
        status: StepStatus.NOT_INITIATED,
        paymentCreateStatus: StepStatus.NOT_INITIATED,
        paymentApplyStatus: StepStatus.NOT_INITIATED,
    },
    ReconcileCreditMemoToInvoice: {
        name: "Reconcile Credit Memo To Invoice",
        status: StepStatus.NOT_INITIATED,
    },
    CreateJournalEntry: {
        name: "Create AIC Journal Entry",
        status: StepStatus.NOT_INITIATED,
        aijeCreateStatus: StepStatus.NOT_INITIATED,
        aijeApplyStatus: StepStatus.NOT_INITIATED,
    },
    TurnOfAutoRenewal: {
        name: "Turn off Auto Renewal",
        status: StepStatus.NOT_INITIATED,
    },
    DeleteDraftSubscription: {
        name: "Delete Draft Subscription",
        status: StepStatus.NOT_INITIATED,
    },
};
var stepConstants_1 = require("./stepConstants");
Object.defineProperty(exports, "LINK_CUSTOMER_TO_TARGET_SUBSIDIARY_STEP_KEY", { enumerable: true, get: function () { return stepConstants_1.LINK_CUSTOMER_TO_TARGET_SUBSIDIARY_STEP_KEY; } });
Object.defineProperty(exports, "LINK_CUSTOMER_TO_TARGET_SUBSIDIARY_STEP_NAME", { enumerable: true, get: function () { return stepConstants_1.LINK_CUSTOMER_TO_TARGET_SUBSIDIARY_STEP_NAME; } });
var normalizeLegacyTransferOutput_1 = require("./normalizeLegacyTransferOutput");
Object.defineProperty(exports, "normalizeLegacyTransferOutput", { enumerable: true, get: function () { return normalizeLegacyTransferOutput_1.normalizeLegacyTransferOutput; } });
var transferOrchestrationSteps_1 = require("./transferOrchestrationSteps");
Object.defineProperty(exports, "TRANSFER_ORCHESTRATION_STEP_KEYS", { enumerable: true, get: function () { return transferOrchestrationSteps_1.TRANSFER_ORCHESTRATION_STEP_KEYS; } });
Object.defineProperty(exports, "mergeTransferOutputWithDefaults", { enumerable: true, get: function () { return transferOrchestrationSteps_1.mergeTransferOutputWithDefaults; } });
Object.defineProperty(exports, "visibleTransferOrchestrationStepKeys", { enumerable: true, get: function () { return transferOrchestrationSteps_1.visibleTransferOrchestrationStepKeys; } });
